/**
 * Format a share as a percentage, avoiding false "100%" or "0%" when the other count is above 0.
 *
 * Returns:
 * - "100%" only when part === total
 * - "0%" only when part === 0
 * - ">99%" when rounded percentage would be 100 but part !== total
 * - "<1%" when rounded percentage would be 0 but part > 0
 * - A normal percentage string for all other values (e.g., "50%", "23%")
 */
export const formatShare = (part: number, total: number): string => {
  if (total === 0) return '0%';
  if (part === total) return '100%';
  if (part === 0) return '0%';

  const percentage = Math.round((part / total) * 100);

  if (percentage === 100) return '>99%';
  if (percentage === 0) return '<1%';

  return `${percentage}%`;
};
